import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import {
  ILabReportListResponse,
  ILabReportListResponseData,
  ILabReportStatsParamsBody,
} from "@/api_framework/api_modals/LabReport";
import { setLabReportDataList } from "@/app_redux/reducers/slices/auth/lab_report_slice";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string; data?: ILabReportListResponseData[] };

// silent: return the rows without writing them (or the loading flag) to the store,
// for callers that combine several responses before dispatching once.
type LabReportFilterListOptions = { silent?: boolean };

export const useLabReportFilterListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (
      filterParams: ILabReportStatsParamsBody,
      options: LabReportFilterListOptions = {},
    ): Promise<InventoryTaxCreateAPIResponse> => {
      const { silent = false } = options;
      const setTableLoading = (status: boolean) => {
        if (!silent) dispatch(setLoading({ key: "isCustomerInvoiceTableInProgress", status }));
      };
      const publish = (data: ILabReportListResponseData[]) => {
        if (!silent) dispatch(setLabReportDataList({ data }));
        setTableLoading(false);
      };

      try {
        setTableLoading(true);
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(LAB_REPORT?.LAB_REPORT_FILTER_LIST?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ILabReportListResponse>) => {
            if (res.data.status === true) {
              publish(res.data.data);
              return { status: true, message: "batch", data: res.data.data };
            }
            publish([]);
            return { status: false, message: "data_not_filtered", data: [] };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            publish([]);
            return { status: false, message: "data_not_filtered", data: [] };
          });
        return response;
      } catch (e: any) {
        publish([]);
        return { status: false, message: "data_not_filtered", data: [] };
      }
    },
    [dispatch],
  );
  return { execute };
};
